'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogoutUI = function () {
   function LogoutUI() {
      _classCallCheck(this, LogoutUI);
   }

   _createClass(LogoutUI, null, [{
      key: 'init',
      value: function init() {
         LogoutUI.waiting_for = $('.mais-logout-frame').length;
         LogoutUI.shown_done = false;
         if (!LogoutUI.waiting_for) {
            $('#logging_out').hide();
            $('#logged_out').show();
         } else {
            // Wait for each Frame to load
            $('.mais-logout-frame').on('load', LogoutUI.onLoad);
            // Overall Timeout after which we give up
            LogoutUI.timeout = setTimeout(function () {
               LogoutUI.waiting_for = 0;
               LogoutUI.check(0);
            }, 10000);
         }
      }
   }, {
      key: 'onLoad',
      value: function onLoad() {
         console.log('Logout complete:', $(this).data('id'));
         setTimeout(function () {
            LogoutUI.waiting_for--;
            LogoutUI.check();
         }, 1000);
      }
   }, {
      key: 'check',
      value: function check() {
         if (LogoutUI.waiting_for == 0 && !LogoutUI.shown_done) {
            LogoutUI.shown_done = true;
            $('#logging_out').fadeTo('slow', 0, function () {
               $('#logging_out').hide();
               $('#logged_out').fadeTo('slow', 1);
            });
            if (LogoutUI.timeout) clearTimeout(LogoutUI.timeout);
         }
      }
   }]);

   return LogoutUI;
}();

module.exports = LogoutUI;


//////////////////
// WEBPACK FOOTER
// ./client/js/logout-ui.js
// module id = 139
// module chunks = 0